import React from "react";
import { View, StyleSheet } from "react-native";
import BaseController from "../../common/base/BaseController";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtPageActionButton from "../../components/NtPageActionButton";
import NtSearchBar from "../../components/NtSearchBar";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtListRow from "../../components/NtListRow";
import Logger from "../../common/utils/Logger";
import { fetchExtensions } from "../../api/extension";
import settings from "../../config/settings";
import extensioncsvcolumndata from "../data/extensioncsvcolumndata";
import { asyncStorageSetData } from "../../common/utils/ControllerUtils";
import { isPhysicalExtension, parseExtension } from "../utils/ExtensionUtils";

class GatewayController extends BaseController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    page: 1,
  };

  column_location = "@gateway_column_storage";

  componentDidMount() {
    this.handleDefaultColumnsFetch(
      this.column_location,
      extensioncsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    this.setState({ loading: true });
    const response = await fetchExtensions(
      this.context.user?.domain,
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
      { gateway: this.props.route?.params?.gateway },
    );
    if (response.ok) {
      this.setState({
        data: response.data?.extensions || [],
        totalItems: response.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const response = await fetchExtensions(
      this.context.user?.domain,
      1,
      10000000,
      this.state.searchText,
      { gateway: this.props.route?.params?.gateway },
    );
    return response.ok ? response.data.extensions : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "extension") return parseExtension(item[column]);
    if (column === "description") {
      if (isPhysicalExtension(item[column])) {
        return `"Gateway: ${item[column]?.split(",")[0]}, Port: ${item[column]?.split(",")[1]}"`;
      }
    }
    if (column === "toll_allow") return item[column] === "t" ? "True" : "False";
    return item[column];
  };

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  handleOpenGateway = () => {
    // Octet was previously per-environment (a private-IP scheme for shipboard
    // installs). Single-platform Business SaaS doesn't carry one; default to 0.
    const octet = this.context.user?.gatewayOctet ?? 0;
    const url = `http://10.26.${octet}.${80 + parseInt(this.props.route?.params?.gateway)}`;
    Logger("Opening gateway URL: ", url);
    if (typeof window !== "undefined") window.open(url);
  };

  renderRow = (item, index) => (
    <NtListRow
      key={item.extension_uuid || index}
      item={item}
      columns={this.state.columns}
      renderCustom={(row, column) => {
        if (column === "description") return `Port: ${row[column]?.split(",")[1]}`;
        if (column === "extension") return parseExtension(row[column]);
        if (column === "toll_allow") return row[column] === "t" ? "True" : "False";
      }}
    />
  );

  render() {
    const subtitle = `${this.state.totalItems || 0} extension${this.state.totalItems === 1 ? "" : "s"}`;

    const actions = (
      <NtPageActionButton
        icon="open-in-new"
        title="View Gateway"
        variant="primary"
        onPress={this.handleOpenGateway}
      />
    );

    const searchBar = (
      <NtSearchBar value={this.state.searchText} onChangeText={this.handleSearch} />
    );

    return (
      <NtRootPageContainer
        pageTitle={`Gateway ${this.props.route?.params?.gateway}`}
        pageSubtitle={subtitle}
        permission={this.handlePermissionCheck()}
        actions={actions}
        showBackButton
      >
        <NtPageSection
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              columns={extensioncsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="gateway"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map((each, index) => this.renderRow(each, index))}
          </View>
        </NtPageSection>
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default GatewayController;
